import { create } from 'zustand';

const KEY = 'rm_sidebar_collapsed';

// Browser storage can be blocked (private mode); the toggle must work without it.
const readCollapsed = () => {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
};
const writeCollapsed = (value) => {
  try { localStorage.setItem(KEY, value ? '1' : '0'); } catch { /* ignore */ }
};

const useUIStore = create((set) => ({
  // Mobile drawer
  sidebarOpen: false,
  // Desktop: icons-only sidebar (remembered between visits)
  sidebarCollapsed: readCollapsed(),
  loading: false,

  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  setSidebarOpen: (open) => set({ sidebarOpen: open }),

  toggleSidebarCollapsed: () =>
    set((state) => {
      const next = !state.sidebarCollapsed;
      writeCollapsed(next);
      return { sidebarCollapsed: next };
    }),

  setLoading: (loading) => set({ loading }),
}));

export default useUIStore;
